import { DomainMap, RegionalDomain } from "src/config/BartLambdaConfig";

/**
 * Fuse Portal plan page URL prefixes, keyed by Bart regional domain. This is
 * the single source of truth for plan links: every plan link in the portal
 * must be built with {@link getFusePortalPlanUrl} rather than by assembling
 * the URL locally, so a new region or a URL change is a one-line edit here.
 */
const FUSE_PORTAL_PLAN_PREFIX_DOMAIN_MAP: DomainMap<string> = {
  "prod-FE": "https://fuse-portal.harmony.a2z.com/prod-fe/plans/",
  "prod-US": "https://fuse-portal.harmony.a2z.com/prod-na/plans/",
  "prod-EU": "https://fuse-portal.harmony.a2z.com/prod-eu/plans/",
  default: "https://fuse-portal.harmony.a2z.com/devo-na/plans/",
};

/** Returns the Fuse Portal plan page URL for the given domain and plan id. */
export const getFusePortalPlanUrl = (
  domain: RegionalDomain,
  fusePlanId: string,
): string =>
  `${
    FUSE_PORTAL_PLAN_PREFIX_DOMAIN_MAP[domain] ??
    FUSE_PORTAL_PLAN_PREFIX_DOMAIN_MAP.default
  }${fusePlanId}`;
